export default __webpack_public_path__ + "static/media/Cloudinary-Logo.df0c0e93.svg";